import { colors } from "../../Styles";

  export type Group = {
    groupId: number; //DataTYPE ID, static
    groupName: string;
  };
  
  export const AnimalGroupData: Group[] = [
    {
      groupId: 1,
      groupName: "1.1"
    },
    {
      groupId: 2,
      groupName: "2.2"
    },
    {
      groupId: 3,
      groupName: "3.3"
    },
    {
      groupId: 4,
      groupName: "4.4"
    },
    {
      groupId: 5,
      groupName: "5.5"
    },
  ]

